import { render, staticRenderFns } from "./notwx.vue?vue&type=template&id=145efd02&scoped=true"
import script from "./notwx.vue?vue&type=script&lang=js"
export * from "./notwx.vue?vue&type=script&lang=js"
import style0 from "./notwx.vue?vue&type=style&index=0&id=145efd02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145efd02",
  null
  
)

export default component.exports